module.exports = __webpack_public_path__ + "static/media/logoblack.b204d6c6.png";